import { Action } from '@ngrx/store';
import { UserInvitation } from '@model';

export enum CustomerInvitationsActionTypes {
  BulkCreateCustomerInvitations = '[CustomerInvitations] Bulk create',
  BulkCreateCustomerInvitationsSuccess = '[CustomerInvitations] Bulk create success',
  BulkCreateCustomerInvitationsFail = '[CustomerInvitations] Bulk create fail',

  BulkCreateCustomersInvitations = '[CustomersInvitations] Bulk create',
  BulkCreateCustomersInvitationsSuccess = '[CustomersInvitations] Bulk create success',
  BulkCreateCustomersInvitationsFail = '[CustomersInvitations] Bulk create fail',
  BulkCreateCustomersInvitationsCompleted = '[CustomersInvitations] Bulk create completed',

  CustomerInvitationRemove = '[CustomerInvitation] Remove',
  CustomerInvitationRemoveSuccess = '[CustomerInvitation] Remove success',
  CustomerInvitationRemoveFail = '[CustomerInvitation] Remove fail',

  CustomerInvitationSend = '[CustomerInvitation] Send',
  CustomerInvitationSendSuccess = '[CustomerInvitation] Send success',
  CustomerInvitationSendFail = '[CustomerInvitation] Send fail',

  CustomersInvitationsLoadData = '[CustomersInvitations] Load data',
  CustomersInvitationsLoadSuccess = '[CustomersInvitations] Load success',
  CustomersInvitationsLoadFail = '[CustomersInvitations] Load fail',

  CustomersInvitationsSend = '[CustomersInvitations] Send',
  CustomersInvitationsSendSuccess = '[CustomersInvitations] Send success',
  CustomersInvitationsSendFail = '[CustomersInvitations] Send fail',
}

export class BulkCreateCustomerInvitations implements Action {
  readonly type = CustomerInvitationsActionTypes.BulkCreateCustomerInvitations;
  constructor(public payload: UserInvitation[]) {}
}
export class BulkCreateCustomerInvitationsSuccess implements Action {
  readonly type = CustomerInvitationsActionTypes.BulkCreateCustomerInvitationsSuccess;
  constructor(public payload: UserInvitation[]) {}
}
export class BulkCreateCustomerInvitationsFail implements Action {
  readonly type = CustomerInvitationsActionTypes.BulkCreateCustomerInvitationsFail;
  constructor(public payload: any) {}
}

export class BulkCreateCustomersInvitations implements Action {
  readonly type = CustomerInvitationsActionTypes.BulkCreateCustomersInvitations;
  constructor(public payload: UserInvitation[]) {}
}
export class BulkCreateCustomersInvitationsSuccess implements Action {
  readonly type = CustomerInvitationsActionTypes.BulkCreateCustomersInvitationsSuccess;
  constructor(public payload: boolean) {}
}

export class BulkCreateCustomersInvitationsCompleted implements Action {
  readonly type = CustomerInvitationsActionTypes.BulkCreateCustomersInvitationsCompleted;
  constructor(public payload: boolean) {}
}

export class BulkCreateCustomersInvitationsFail implements Action {
  readonly type = CustomerInvitationsActionTypes.BulkCreateCustomersInvitationsFail;
  constructor(public payload: any) {}
}
export class CustomerInvitationRemove implements Action {
  readonly type = CustomerInvitationsActionTypes.CustomerInvitationRemove;
  constructor(public payload: UserInvitation) {}
}

export class CustomerInvitationRemoveSuccess implements Action {
  readonly type = CustomerInvitationsActionTypes.CustomerInvitationRemoveSuccess;
  constructor(public payload: UserInvitation) {}
}

export class CustomerInvitationRemoveFail implements Action {
  readonly type = CustomerInvitationsActionTypes.CustomerInvitationRemoveFail;
  constructor(public payload: any) {}
}

export class CustomerInvitationSend implements Action {
  readonly type = CustomerInvitationsActionTypes.CustomerInvitationSend;
  constructor(public payload: UserInvitation) {}
}

export class CustomerInvitationSendSuccess implements Action {
  readonly type = CustomerInvitationsActionTypes.CustomerInvitationSendSuccess;
  constructor(public payload: UserInvitation) {}
}

export class CustomerInvitationSendFail implements Action {
  readonly type = CustomerInvitationsActionTypes.CustomerInvitationSendFail;
  constructor(public payload: any) {}
}

// (All Users) Customers Invitations
export class CustomersInvitationsLoadData implements Action {
  readonly type = CustomerInvitationsActionTypes.CustomersInvitationsLoadData;
  constructor() {}
}
export class CustomersInvitationsLoadSuccess implements Action {
  readonly type = CustomerInvitationsActionTypes.CustomersInvitationsLoadSuccess;
  constructor(public payload: UserInvitation[]) {}
}
export class CustomersInvitationsLoadFail implements Action {
  readonly type = CustomerInvitationsActionTypes.CustomersInvitationsLoadFail;
  constructor(public payload: any) {}
}

export type CustomerInvitationsActions =
  | BulkCreateCustomerInvitations
  | BulkCreateCustomerInvitationsSuccess
  | BulkCreateCustomerInvitationsFail
  | BulkCreateCustomersInvitations
  | BulkCreateCustomersInvitationsSuccess
  | BulkCreateCustomersInvitationsFail
  | BulkCreateCustomersInvitationsCompleted
  | CustomerInvitationRemove
  | CustomerInvitationRemoveSuccess
  | CustomerInvitationRemoveFail
  | CustomerInvitationSend
  | CustomerInvitationSendSuccess
  | CustomerInvitationSendFail
  | CustomersInvitationsLoadData
  | CustomersInvitationsLoadSuccess
  | CustomersInvitationsLoadFail;
